import PrimitivesFreedomSnippet from "snippets/primitives-freedom.mdx";
import PrimitivesStillSnippet from "snippets/primitives-still.mdx";
import * as React from 'react';
export default {
  PrimitivesFreedomSnippet,
  PrimitivesStillSnippet,
  React
};